import Vue from 'vue'

import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'

// Polyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'

// SASS
//import '../styles/main.scss'

// Components
import ToggleCampus from './components/ToggleCampus'
import BaseWindowWidth from './components/BaseWindowWidth'
import ToggleCampusPanel from './components/ToggleCampusPanel'
import NumberPrecision from './components/NumberPrecision'
import Alerts from './components/Alerts'
import SearchResults from './components/SearchResults'
import SwitchTabinfo from './components/SwitchTabinfo'
import SwitchTabinfoPanel from './components/SwitchTabinfoPanel'
import PieChart from './components/PieChart'
import EventDate from './components/EventDate'
import FooterDate from './components/FooterDate'
import LinkCover from './components/LinkCover'
import SubNav from './components/SubNav'
import SubNavLink from './components/SubNavLink'
import BioAccordion from './components/BioAccordion'

// Helper function for registration
import register from './util/functions/register'

// Plugins
import Header from './components/header/index'
import Tabs from './components/tabs/index'
import Carousel from './components/carousel/index'
import Accordion from './components/accordion/index'
import BackgroundVideo from './components/background-video/index'
import ModalVideo from './components/modal-video/index'
import FormElements from './components/form-elements/index'

// Accessibility
import DiscernableContent from './components/DiscernableContent'

// RSS Parser
//import RssParser from './components/RssParser'

// disclosure
import Dislcosure from './components/disclosure/index'

// remount on window width
import RemountOnWindowWidth from './components/RemountOnWindowWidth'

// News
import NewsPost from './components/news/NewsPost'
import SearchPagination from './components/news/SearchPagination'
import NewsSearchBar from './components/news/NewsSearchBar'
import NewsSearchResults from './components/news/NewsSearchResults'
import TweetThisContainer from './components/news/TweetThisContainer'
import GlobalRfi from './components/GlobalRfi'

const Components = {
  ...Dislcosure,
  RemountOnWindowWidth,
  ToggleCampus,
  BaseWindowWidth,
  ToggleCampusPanel,
  DiscernableContent,
  NumberPrecision,
  Alerts,
  SearchResults,
  SwitchTabinfo,
  SwitchTabinfoPanel,
  PieChart,
  EventDate,
  LinkCover,
  //RssParser,
  FooterDate,
  SubNav,
  SubNavLink,
  NewsPost,
  NewsSearchBar,
  NewsSearchResults,
  SearchPagination,
  TweetThisContainer,
  BioAccordion,
  GlobalRfi,
}

// Component Registration
register(Vue, Components)

// Plugin Invocation
Vue.use(Header)
Vue.use(Tabs)
Vue.use(Carousel)
Vue.use(Accordion)
Vue.use(BackgroundVideo)
Vue.use(HighchartsVue, {
  highcharts: Highcharts,
})
Vue.use(ModalVideo)
Vue.use(FormElements)

Vue.config.silent = true

new Vue({
  delimiters: ['<%', '%>'],
  mounted() {
    svg4everybody()
    objectFitImages()
  },
}).$mount('#app')
